import { faEye, faEyeSlash, faRightFromBracket, faUser, faCalendarDay, faLaptopMedical,
  faSuitcaseMedical, faUserDoctor, faUsers, faClipboard, faClipboardList, faScaleUnbalanced,
  faPenToSquare, faTrashCan, faPlus, faXmark, faBullseye, faBowlFood, faGear, faCommentDots,
  faPaperPlane, faCircleCheck as faCircleCheckSolid, faVideo, faCog, faSquarePlus, faSquareMinus,
  faClock, faPaperclip, faMicrophone, faStop, faPlay, faPause, faChartLine, faCapsules, faTableCells,
  faDownload,
} from '@fortawesome/free-solid-svg-icons';
import { faComment, faBell, faFileLines, faCircleCheck, faCalendar } from '@fortawesome/free-regular-svg-icons';
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faEye);
library.add(faEyeSlash);
library.add(faRightFromBracket);
library.add(faUser);
library.add(faComment);
library.add(faBell);
library.add(faFileLines);
library.add(faCalendarDay);
library.add(faLaptopMedical);
library.add(faSuitcaseMedical);
library.add(faUserDoctor);
library.add(faUsers);
library.add(faClipboard);
library.add(faClipboardList);
library.add(faScaleUnbalanced);
library.add(faPenToSquare);
library.add(faTrashCan);
library.add(faPlus);
library.add(faXmark);
library.add(faBullseye);
library.add(faBowlFood);
library.add(faGear);
library.add(faCircleCheck);
library.add(faCommentDots);
library.add(faPaperPlane);
library.add(faCircleCheckSolid);
library.add(faVideo);
library.add(faCog);
library.add(faSquarePlus);
library.add(faSquareMinus);
library.add(faCalendar);
library.add(faClock);
library.add(faPaperclip);
library.add(faMicrophone)
library.add(faStop)
library.add(faPlay)
library.add(faPause)
library.add(faChartLine)
library.add(faCapsules)
library.add(faTableCells)
library.add(faDownload)